import Vue from 'vue'
import Vuex from 'vuex'
import {getStore, setStore} from '@/publicResource/utils/utils.js'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    locale: ''
  },
  mutations: {
    //
    setLocale (state, info) {
      state.locale = info
      //   setStore('locale', info)
    //   console.log(info)
    }
    // getLocale (state) {
    //   state.locale = getStore('locale')
    // }
  }

})



// WEBPACK FOOTER //
// ./src/publicResource/utils/state.js